import adminapi from './axios.v2.withoutTransform'

const updateInviteNotes = obj => {
  return adminapi('boxOffice/updateInviteNotes', 'PUT', obj)
}

export default {
  updateInviteNotes,
}
